import { createSvgComponent } from "../../icon/createSvgComponent";
import ShareLink from "@core/__generated__/icon/figma/share-link.svg";
export default createSvgComponent(ShareLink);